export enum PATH {
  LANDING = '/',
  ERROR = '/error',
  ADULT = '/adult',
  PROFILE = '/profile',
  JACKPOT = '/jackpot',
  REFERRAL = '/referral',
  // LOTTERY_IN_TURN = '/lottery-in-turn',
  FORBIDDEN_COUNTRY = '/forbidden-country',
  LOTTERY_ALL_AT_ONCE = '/lottery-all-at-once',
  ACCOUNT = '/account',
  SETTINGS = '/settings',

  FAQ = '/faq',
  LOGIN = '/login',
  REGISTER = '/register',
}
